module.exports = __webpack_public_path__ + "static/media/phone-03.1474092c.png";